import { ASSETS_TYPE } from '@/types/shared/navigation-tabs.enums';
import React from 'react';
import { useAppFilters } from './useAppFilters';

/**
 * Custom hook to determine the currently active asset type
 * based on the global application filters.
 *
 * @returns {Object} An object with three boolean flags:
 * - `isMobileAsset`: true if the current asset type is MOBILE.
 * - `isFixedAssets`: true if the current asset type is FIXED.
 * - `isAllAssets`: true if the current asset type is ALL.
 */
export function useActiveAssetsType() {
  const { assetsType } = useAppFilters();

  const isMobileAsset = assetsType === ASSETS_TYPE.MOBILE;
  const isFixedAssets = assetsType === ASSETS_TYPE.FIXED;
  const isAllAssets = assetsType === ASSETS_TYPE.ALL;

  return { isMobileAsset, isFixedAssets, isAllAssets };
}
